import { render, staticRenderFns } from "./ContactsBranches.vue?vue&type=template&id=5668d1ef&lang=pug"
import script from "./ContactsBranches.vue?vue&type=script&lang=js"
export * from "./ContactsBranches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports